<!--
Author:
Create Time: 2020-04-10 14:06:26
Description: 人口信息参照框
-->
<template>
  <el-dialog
    title="人口参照"
    :before-close="handleCancel"
    :close-on-click-modal="false"
    :append-to-body="true"
    :modal="true"
    v-dialogDrag
    v-bind="{...$props, ...$attrs, visible: mVisible}"
    style="margin-top:60px;"
  >
    <el-form :inline="true" :model="condition" size="mini" label-suffix=":" >
      <el-form-item label="姓名">
        <el-input v-model="condition.name" placeholder="模糊查询"></el-input>
      </el-form-item>
      <el-form-item label="联系电话">
        <el-input v-model="condition.phone" placeholder="模糊查询"></el-input>
      </el-form-item>

      <el-form-item label="证件号码">
        <el-input v-model="condition.cardEQ" placeholder="精确查询"></el-input>
      </el-form-item>

      <el-form-item>
        <el-button @click="search" style="background: #3C78FF;margin-left:10px;" type="primary" icon="el-icon-search"><span>搜索</span></el-button>
        <el-button  @click="reset" style="background: #3C78FF;margin-left:10px;" type="primary" icon="el-icon-refresh"><span>重置</span></el-button>
      </el-form-item>
    </el-form>
    <div style="padding: 10px 10px;height:360px; padding-bottom: 2em;">
      <el-table
        :data="pageData.list"
        border
        class="table"
        ref="multipleTable"
        align="center"
        height="100%"
        :stripe="true"
        :header-cell-style="{background:'#F2F2F2',color:'#606266'}"
        @row-click="handleRowClick"
        @selection-change="handleSelectionChange"
        :key="multiple ? 'multiple' : 'radio'"
      >
        <el-table-column width="50" fixed="left" align="center" show-overflow-tooltip v-if="!multiple">
          <template slot-scope="scope">
            <el-radio :label="scope.row.id" v-model="selectedRowId">&nbsp;</el-radio>
          </template>
        </el-table-column>
        <el-table-column width="50" fixed="left" align="center" show-overflow-tooltip v-if="multiple" type="selection"></el-table-column>

        <el-table-column prop="name" align="center" label="姓名" min-width="180" show-overflow-tooltip sortable></el-table-column>
        <el-table-column prop="sex" align="center" label="性别" min-width="180" show-overflow-tooltip sortable width="80"></el-table-column>
        <el-table-column prop="phone" align="center" label="联系电话" min-width="180" show-overflow-tooltip sortable></el-table-column>
        <el-table-column prop="nationality" align="center" label="国籍" min-width="180" show-overflow-tooltip sortable></el-table-column>
        <el-table-column prop="idCard" align="center" label="身份证" min-width="180" show-overflow-tooltip sortable></el-table-column>
      </el-table>
      <div data-ignore-class="pagination">
        <pagination
          data-ignore-style="float:right"
          style="text-align: right;"
          :page-list="pageData"
          @pagesearch="handlePage"
        ></pagination>
      </div>
    </div>

    <span slot="footer">
      <el-button icon="el-icon-back" size="medium" @click="handleCancel">取消</el-button>
      <el-button type="primary" icon="el-icon-document" size="medium" @click="handleConfirm">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>

  function newSearchCondition() {
    return {
      // 查询列表数据的条件
      loginUser: window.sessionStorage.getItem("userId"),

      name: undefined,
      phone: undefined,
      cardEQ: undefined,
    };
  }

  export default {
    name: "populregisterRef",
    data() {
      return {
        condition: newSearchCondition(),
        pageData: {
          list: [],
          pageNumber: 1,
          pageSize: 10,
          totalCount: 0,
          totalPage: 0
        },
        selectedRowId: "", //单选列表选中的id

        selection: [],

        sexOptions4Form: [],
        categoryOptions4Form: [],
        identityTypeOptions4Form: [],
        maritalStatusOptions4Form: [],
        politicsStatusOptions4Form: [],
        householderRelationOptions4Form: [],
        isEnterpriseOptions4Form: [],
        isDieOptions4Form: [],
        degreeEducationOptions4Form: [],
        religionOptions4Form: [],
        emergencyContactRelationOptions4Form: [],
        statusOptions4Form: [],

        yesOrNoOptions: [],
        mVisible: false,
      };
    },
    watch: {
      visible(val) {
        if (val) {
          this.condition = newSearchCondition();
          if(this.custByorgId){
            this.condition.orgId = window.sessionStorage.getItem("orgId");
          }
          if(this.politicsStatus == true) {
          this.condition.politicsStatus = '10'
        }
         if(this.houseId != "" && this.houseId != undefined){
            this.condition.houseId = this.houseId
        }
         if(this.notHistoryAndIsChargeObj!=""&&this.notHistoryAndIsChargeObj!=undefined){
            this.condition.notHistoryAndIsChargeObj = this.notHistoryAndIsChargeObj;
         }
            this.condition.sex = this.sex;

          this.search().then(() => this.mVisible = true);

          this.selectedRowId = null;
          this.selection = [];
        } else {
          this.mVisible = false;
        }
      }
    },
    props: {
      custByorgId: {//房客关系人员过滤本社区内客户
        type: Boolean,
        default: () => false
      },
      custAddCheck: {//客户档案新增属性：true-排除数据空校验
        type: Boolean,
        default: () => false
      },
      visible: {
        type: Boolean,
        default: () => false
      },
      multiple: {
        type: Boolean,
        default: () => false
      },
      width: {
        type: String,
        default: () => "80%"
      },
      sex: {
        type: String,
        default: () => ""
      },
      politicsStatus: {
      type: Boolean,
      default: () => false
    },
    houseId: {
      type: String,
      default: () => ""
    },
    notHistoryAndIsChargeObj: {//非历史且是收费对象的用户（适用于费用计算）
      type: String,
      default: () => ""
    }
  },
    methods: {
      handleCancel() {
        this.$emit("cancel");
      },
      handleConfirm() {
        if (this.multiple ? (this.selection.length === 0) : !this.selectedRowId && !this.custAddCheck) {
          this.$message.warning('请选择数据');
          return;
        }
        this.$emit(
          "confirm",
          this.multiple ? this.selection : this.pageData.list.find(item => item.id === this.selectedRowId)
        );
      },
      search() {
        this.pageData.pageNumber= 1;
        return this.getData(this.pageData.pageNumber, this.pageData.pageSize);
      },
      reset() {
        this.condition.name = "";
        this.condition.phone = "";
        this.condition.cardEQ = "";
        this.search();
      },
      getData(number, size) {
        return this.$http
          .post(this.api.ProPopulregisterQueryByCondition, {
            condition: this.condition,
            number: number,
            size: size
          })
          .then(res => {
            if (res.data && res.data.code === "200") {
              this.pageData.list = res.data.body.records;
              this.pageData.totalCount = res.data.body.total;
              this.pageData.totalPage = res.data.body.pages;
            }
          });
      },
      handlePage(number, size) {
        this.pageData.pageNumber = number;
        this.pageData.pageSize = size;
        this.getData(this.pageData.pageNumber, this.pageData.pageSize);
      },
      //行选择
      handleRowClick(row) {
        this.selectedRowId = row.id;
      },
      handleSelectionChange(selection) {
        this.selection = selection;
      },
    },
    mounted() {
      this.yesOrNoOptions = [ { label: '是', value: '是' }, { label: '否', value: '否' } ];
      let yesOrNoOptions = this.yesOrNoOptions;
      let sysDic = JSON.parse(localStorage.getItem('sysDic')||'{}');

      /* ---- 人口基本信息 ---- */
      this.sexOptions4Form = [ { label: '男', value: '男' }, { label: '女', value: '女' } ];
      this.categoryOptions4Form = sysDic.hkxz||[];
      this.identityTypeOptions4Form = sysDic.sflb||[];
      this.maritalStatusOptions4Form = sysDic.hyzt||[];
      this.politicsStatusOptions4Form = sysDic.zzmm||[];
      this.isCtyCensusOptions4Form = yesOrNoOptions;
      this.householderRelationOptions4Form = sysDic.yzgx||[];
      this.isEnterpriseOptions4Form = yesOrNoOptions;
      this.isDieOptions4Form = yesOrNoOptions;
      this.degreeEducationOptions4Form = sysDic.jycd||[];
      this.religionOptions4Form = sysDic.zjxy||[];
      this.emergencyContactRelationOptions4Form = sysDic.qsgx||[];
      this.statusOptions4Form = sysDic.enabled||[];
    }
  };
</script>

<style scoped lang="less">
  // .com-populregister-ref {}
  .el-form-item .el-button span{
    font-family: "microsoft yahei";
    font-size: 14px;
    color: #FFFFFF;
    text-align: left;
  }
</style>



// WEBPACK FOOTER //
// src/components/populregister/populregisterRef.vue